import { isElementInViewport } from '@theme/utilities';

class StickyAddToCart extends HTMLElement {
  // Fonction gardée en mémoire pour pouvoir retirer l'écouteur plus tard
  #onScroll = () => this.#update();
  // Vrai si l'écran fait 749px de large ou moins (seuil mobile Shopify)
  #mobileQuery = window.matchMedia('(max-width: 750px)');
  #variantPickerJoined = false;

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    if (!this.form) return;

    this.formTag = this.form.querySelector('form');
    this.footer = document.querySelector('[data-ref="footer"]');
    this.variantPickerContainer = this.formTag?.querySelector('.variant-picker-container');
    this.variantPicker = this.formTag?.querySelector('variant-picker');

    this.#update();
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#mobileQuery.addEventListener('change', this.#onScroll);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#onScroll);
    this.#mobileQuery.removeEventListener('change', this.#onScroll);
  }

  /** Réglage de l'éditeur de thème : "none" | "mobile" | "all" */
  get alwaysVisible() {
    const mode = this.dataset.alwaysVisible;
    if (mode === 'all') return true;
    if (mode === 'mobile') return this.#mobileQuery.matches;
    return false;
  }

  #update() {
    const footerVisible = this.footer ? isElementInViewport(this.footer) : false;
    const formOutOfView = !isElementInViewport(this.form) && !this.#isScrollBeforeForm();

    // Toujours visible : affichée partout sauf au-dessus du footer
    // Sinon : affichée seulement une fois le formulaire dépassé
    const isActive = this.alwaysVisible
      ? !footerVisible
      : formOutOfView && !footerVisible;

    this.dataset.active = String(isActive);
    this.classList.toggle('color-scheme-1', isActive);

    if (this.dataset.displayVariantPicker === 'true') {
      // On ne déplace le sélecteur que si le formulaire principal n'est plus visible
      this.#syncVariantPicker(isActive && formOutOfView);
    }
  }

  #isScrollBeforeForm() {
    return window.scrollY < this.form.offsetTop;
  }

  #syncVariantPicker(shouldJoin) {
    if (!this.variantPicker || shouldJoin === this.#variantPickerJoined) return;
    this.#variantPickerJoined = shouldJoin;

    setTimeout(() => {
      const target = shouldJoin
        ? this.querySelector('.sticky-add-to-cart__product-infos-container')
        : this.variantPickerContainer;
      target?.append(this.variantPicker);
    }, 300);
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}